<template>
  <div class="card modal-card">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('detailSociete.fusionSociete.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <error-msg-component
        :error="error"
        :messages="messages"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields
      />
      <div class="">
        <div class="card">
          <header class="header-card">
            <p> {{ $t('detailSociete.fusionSociete.societeOrigine') }} </p>
          </header>
          <div class="card-content">
            <societe-info-fusion :societe="societe"/>
          </div>
        </div>
        <div class="card mgt-20px">
          <header class="header-card">
            <p> {{ $t('detailSociete.fusionSociete.societeDestinataire') }} </p>
          </header>
          <div class="card-content">
            <b-field >
              <b-select
                :placeholder="$t('detailSociete.fusionSociete.placeholder')"
                @input="updateSelected"
                expanded>
                <option
                  v-for="societe in filteredSocietes"
                  :value="societe"
                  :key="societe.codeSociete">
                  {{ societe.libelle }}
                </option>
              </b-select>
            </b-field>
            <societe-info-fusion
              v-if="societeDestinataire"
              :societe="societeDestinataire"/>
          </div>
        </div>
      </div>
      <footer class="buttons mgt-20px">
        <qd-button
          @click="$parent.close()"
          type="is-light"
          class="btn-modal-annuler">
          {{$t('general.button.cancel')}}
        </qd-button>
        <qd-button
          @click="popUpPrevention = true"
          :disabled="!societeDestinataire"
          class="button is-addOrEdit">
          {{$t('general.button.appliquer')}}
        </qd-button>
      </footer>
    </div>
    <b-modal
      v-model="popUpPrevention"
      :width="800"
      has-modal-card
      class="modal">
      <popUpPrevention
        v-if="societeDestinataire"
        :messHeader="$t('detailSociete.fusionSociete.msgPrevention',
        {
          societeOrigine: societe.libelle,
          societeDestinataire: societeDestinataire.libelle
        })"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPrevention = false"
        @yes="appliquer"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { fusionSocieteAsync } from '@/api/societe';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import societeInfoFusion from '@/components/parametrage/societes/societeInfoFusion';
import validationGeneral from '@/services/validation/validation';
import validationFusionSociete from '@/services/societe/validationFusionSociete';
import translate from '@/services/societe/translatorFusionSociete';
import { get } from '@/api/utilisateur/index';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  name: 'popupFusionSociete',
  components: {
    errorMsgComponent,
    popUpPrevention,
    societeInfoFusion,
  },
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      popUpPrevention: false,
      societeDestinataire: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    filteredSocietes() {
      return this.societesInformations.filter((societe) => {
        return societe.codeSociete !== this.societe.codeSociete;
      });
    },
  },
  methods: {
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
      actionsSetSocieteOfUser: 'setSocieteOfUser',
    }),
    updateSelected(val) {
      this.societeDestinataire = val;
    },
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.popUpPrevention = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      try {
        await fusionSocieteAsync({
          societeOrigineId: this.societe.id,
          societeDestinationId: this.societeDestinataire.id,
        });
        const user = (await get(this.user.id)).data.result;
        await this.loadSocietes({});
        this.actionsSetSocieteOfUser(user);
        messageSuccess(this.$i18n.t('detailSociete.fusionSociete.success'));
        this.$router.push({
          name: 'c.parametrage.societe/agence',
          params: { id: this.societeDestinataire.id },
        });
        this.$parent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationFusionSociete(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
